import type { GuidedDoctorConsultsState } from '../types';

export const accordionInteractionAnimation = (get: () => GuidedDoctorConsultsState) =>
  get().guidedDoctorConsult.accordionInteractionAnimation;
